import { render, staticRenderFns } from "./ChartDetailsBottomSheet.vue?vue&type=template&id=4bbdd208"
import script from "./ChartDetailsBottomSheet.vue?vue&type=script&lang=js"
export * from "./ChartDetailsBottomSheet.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports